import React from 'react'
import './how_it_works.css'
import vijay from './Im/Vijay.png'
import card from './Im/Card.png'
import wallet from './Im/Wallet.png'
import Fotter from '../../Home/Home_modules/Footerr/footer'
import VerticalTabs from '../../Components/howitworkstab.js'
import { CustomizedAccordions } from '../../Components/howitworkstab.js'


function How_it_works() {
    return (
        <div>
        <div className="main">
        <div className="hiw-section-1">
            <div className="hiw-section1-col1">       
               <h1 className="intro-text">What is an NFT?</h1>   
               <h6>Non-fungible token.</h6>
               <h3>That doesn’t make it any clearer.</h3>
               <p>NFT’s are simply digital art signed using blockchain technology. With the power of blockchain technology, the authenticity of the artwork can never be questioned. NFTs are making waves across the world and have become the new medium for the world's most talented creatives. </p>
               </div>
               <div className="hiw-section1-col2">
                   <img src={vijay} />     
                   </div>  
        </div>
        <div className="faq-section">
        <h1 className="faq-title">FAQs</h1>
        <div className="faq-container">
            <div className="hiw-tabs-d">
            <VerticalTabs />
            </div>
            <div className="hiw-tabs-m">
                <CustomizedAccordions />
            </div>
         {/* <div className="acc-col">    
            <div className="tab">
            <input id="tab-1r" type="radio" name="tabr"/>
            <label for="tab-1r">Creating and connecting NFT wallet</label>
            <div className="tab-content"><p>Creating and connecting NFT wallet
            </p>
            </div>
       </div>
        <div className="tab">
        <input id="tab-2r" type="radio" name="tabr"/>
        <label for="tab-2r">Purchasing NFT</label>
        <div className="tab-content"><p>Purchasing NFT</p>
        </div>
      </div>
      <div className="tab">
       <input id="tab-3r" type="radio" name="tabr"/>
         <label for="tab-3r">Withdrawing NFT into wallet</label>
         <div className="tab-content"><p>An NFT is a digital asset that represents real-world objects like art, music, in-game items and videos. They are bought and sold online, and they are generally encoded with the same underlying software as cryptocurrency. With the underlying blockchain technology of NFTs, you can be the verified owner of our authentic NFTs.
          For instance, the NBA sold a video clip of famous Basketball player Micheal Jordan dunking the basketball for $150,000. This clip is thus owned by a certain person and he may choose to sell it for much more than its original price!</p></div>
      </div>
     <div className="tab">
       <input id="tab-4r" type="radio" name="tabr"/>
       <label for="tab-4r">Listing NFT for sale</label>
       <div className="tab-content"><p>Withdrawing NFT into wallet</p>
       </div>
     </div>
     <div className="tab">
         <input id="tab-5r" type="radio" name="tabr"/>
         <label for="tab-5r">Participating in auctions</label>
         <div className="tab-content"><p>Withdrawing NFT into wallet</p>
         </div>
    </div>
                </div> 
                <div className="faq-video">
                <iframe width="650" height="450" src="https://www.youtube.com/embed/Eqg3YY2tw74?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>*/}
        </div>
    </div>
        <div className="faq-list">
        <div className="tab">
            <input id="tab-6r" type="radio" name="tabr"/>
            <label className="acc-title" for="tab-6r">But can’t I just take a screenshot?</label>
            <div className="tab-content"><p>To best understand the difference between an original NFT and its screenshot, imagine an authentic original renaissance painting and its duplicate. Many great artists have replicated renaissance paintings but the originals are extremely valuable and worth much more than their ditto duplicates. It is the same with NFTs and their screenshots. When you buy an NFT from Diginoor, you get in-built authentication & ownership of the Artwork. Proof that’s preserved forever by blockchain. With ownership, you’ve just become part of a growing group of worldwide collectors.
            </p>
            </div>
       </div>
        <div className="tab">
        <input id="tab-7r" type="radio" name="tabr"/>
        <label className="acc-title" for="tab-7r">What’s the ‘marketplace’?</label>
        <div className="tab-content"><p>With a mission to bring the NFT wave to India. Diginoor has created a marketplace & ecosystem for NFTs & digital art. On the Diginoor marketplace, you can sell your NFTs for higher prices or buy new ones to add to your collection. Apart from NFTs, our marketplace also offers digital art made and approved by our partner production houses and actors! Coming soon for fans worldwide!</p>
        </div>
      </div>
      <div className="tab">
       <input id="tab-8r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-8r">How do I pay for the NFT?</label>
         <div className="tab-content"><p>We’ve got a wide range of payment options for everyone. You can buy our fixed-price NFTs with your credit/debit card via our Stripe payments gateway and also with cryptocurrency in your wallet. For participating in an auction, however, you’ll need to have cryptocurrency in your wallet. You can easily add crypto into your wallet with your Credit/Debit card via our Transak.io integration. Once you buy an NFT or Digital artwork, you’ll be prompted to select a payment method. It’s just that simple.</p></div>
      </div>
     <div className="tab">
       <input id="tab-9r" type="radio" name="tabr"/>
       <label className="acc-title" for="tab-9r">What are royalties?</label>
       <div className="tab-content"><p>At Diginoor we’ve created a platform where all parties involved are taken care of. When production houses, actors & creators partner with us to approve & create amazing art, we give them a percentage of the royalties on every sale. So, for every sale and resale of our NFTs, the concerned production houses receive 10% of the proceedings.</p>
       </div>
     </div>
     <div className="tab">
         <input id="tab-10r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-10r">How do I receive my NFT?</label>
         <div className="tab-content"><p>After winning a bid or completing the payment for your NFT, we transfer the art/NFT to your preferred crypto wallet. If you don’t have a wallet at the time of purchase, don’t worry. We provide a standardised wallet to all our customers, storing your art till you connect your personal wallet & transfer the art. If you don’t know how to create a wallet, we can help you with that too! Check out our wallet creation tutorial.</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-11r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-11r">Is this secure?</label>
         <div className="tab-content"><p>Diginoor is built on the polygon blockchain, which is a side chain of the most secure and popular ethereum. When you buy an NFT on Diginoor, you are uniquely authenticated to the Art. What does that mean? It means in the very code of the NFT, you are recognised as the owner.</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-12r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-12r">Do we have a permit for this?</label>
         <div className="tab-content"><p>We don’t just have a permit, we’ve got the official license. We own the official license for all the content sold on our platform. We have tie-ups with production houses like Reliance entertainment, AVM productions, and every major Indian production house. Our platform boasts unparalleled transparency.</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-13r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-13r">I’m interested in selling my NFT art, how do I sell?</label>
         <div className="tab-content"><p>Diginoor is a place to not just buy but also sell beautiful artwork. Once you buy an NFT at Diginoor, you can either keep ownership or re-sell it on our platform with the full support & features of the Diginoor marketplace. Just contact us & we’ll make it happen!</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-14r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-14r">Are crypto wallets essential to receive my NFT?</label>
         <div className="tab-content"><p>Yes. It is necessary to have a wallet to receive your art. As your unique ownership of Art is an essential feature of all our content. True ownership comes when your NFTs are where they belong- with you!. We require a Digital blockchain wallet to safely deliver your art so that you can safely store your NFT privately. Create a wallet for free here! It’s simple, easy & fast.</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-15r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-15r">Participating in auctions</label>
         <div className="tab-content"><p>You can either load your connected Metamask/Torus wallet with $ETH (Ether) or MATIC (if compatible with your wallet) and choose to pay using your connected wallet at the time of checkout.
You can fill any other crypto wallet with accepted cryptocurrencies and choose to pay using coinbase at the time of checkout.
</p>
         </div>
    </div>
    <div className="tab">
         <input id="tab-16r" type="radio" name="tabr"/>
         <label className="acc-title" for="tab-16r">What are the accepted cryptocurrencies?</label>
         <div className="tab-content"><p>We accept 
Ether, Bitcoin, Ripple, Matic, and Dogecoin.
Don’t have crypto? Feel free to pay by card.
</p>
         </div>
    </div>
                </div>
                <div className="payments-section">
                    <div>
                        <img className="card-image" src={card}/>
                        </div>
                    <div className="payments-text">
                        <h2>payments</h2>
                        <p>We want to make sure everyone is able to own a piece of their favourite movies, which is why the payment process is extremely flexible and user friendly. Users may choose to pay using their credit/debit card or a wide variety of cryptocurrencies. The choice is yours. To make payments secure, we have tied up with industry standard payment gateways Stripe and Coinbase.</p>
                        </div>
                </div>
                
                <div className="wallet-section">
                    <h2>CONNECT A CRYPTO WALLET</h2>
                    <div className="wallet-grid">
                        <div className="wallet-txt">
                            <p>A crypto wallet is a safe storage for your collectibles. When you decide on an NFT to invest in after browsing our vast collection, make sure to connect your crypto wallet before making the purchase. Your purchased NFT will then directly be transferred to your wallet. If you don’t already have a wallet, Diginoor.io will help you create a secure Metamask wallet in just 2 minutes through our self help guides.</p>
                            </div>
                            <div>
                                <img className="wallet-img" src={wallet}/>
                                </div>
                        </div>
                </div>

                
                </div>
                <Fotter/>
                </div>
    )
}

export default How_it_works
